import { IconButton, Stack, Tooltip } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import type { InvoiceEntity } from "../../../../api/types";

export type InvoiceActionsProps = {
  item: InvoiceEntity;
  onEdit: (item: InvoiceEntity) => void;
  onView: (item: InvoiceEntity) => void;
  onViewTransactions: (item: InvoiceEntity) => void;
  size?: "small" | "medium";
};

export const InvoiceActions = ({
  item,
  onEdit,
  onView,
  onViewTransactions,
  size = "medium",
}: InvoiceActionsProps) => (
  <Stack direction="row" spacing={0.5} sx={{ alignItems: "center" }}>
    <Tooltip title="View invoice">
      <IconButton size={size} onClick={() => onView(item)}>
        <VisibilityIcon fontSize={size} />
      </IconButton>
    </Tooltip>
    <Tooltip title="View transactions">
      <IconButton size={size} onClick={() => onViewTransactions(item)}>
        <ReceiptLongIcon fontSize={size} />
      </IconButton>
    </Tooltip>
    <Tooltip title="Edit invoice">
      <IconButton size={size} onClick={() => onEdit(item)}>
        <EditIcon fontSize={size} />
      </IconButton>
    </Tooltip>
  </Stack>
);
